module.exports = {"620924100":"红柳湾镇","620924200":"阿克旗乡","620924203":"阿勒腾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620924.json
// module id = 2723
// module chunks = 0